import { render, staticRenderFns } from "./gridMenuCopy.vue?vue&type=template&id=4e84e80e&scoped=true"
import script from "./gridMenuCopy.vue?vue&type=script&lang=js"
export * from "./gridMenuCopy.vue?vue&type=script&lang=js"
import style0 from "./gridMenuCopy.vue?vue&type=style&index=0&id=4e84e80e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e84e80e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\newWarehouse\\qmsk-platform-supply-merchant-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e84e80e')) {
      api.createRecord('4e84e80e', component.options)
    } else {
      api.reload('4e84e80e', component.options)
    }
    module.hot.accept("./gridMenuCopy.vue?vue&type=template&id=4e84e80e&scoped=true", function () {
      api.rerender('4e84e80e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/components/gridMenuCopy.vue"
export default component.exports